/* eslint-disable no-param-reassign */
/* eslint-disable object-curly-newline */
/* eslint-env jquery */

import { Component, registerComponent } from 'js/component.js';

const componentName = 'product-recommendations';
const productDetailServletEndpoint = '/bin/rockwell-automation/product-details';
const productDetailsPage = '/products/details.';
class ProductRecommendations extends Component {
    elements = {
        container: this.element.querySelector(`.${componentName}__container`),
        productTemplate: this.element.querySelector(`.${componentName}__product-template`),
        basedOnViewsList: this.element.querySelector(`.${componentName}__content--based-on-views .${componentName}__products`),
        bestSellingList: this.element.querySelector(`.${componentName}__content--best-selling .${componentName}__products`),
    };

    constants = {
        productsToDisplay: 4,
        defaultImage: 'https://www.rockwellautomation.com/etc.clientlibs/rockwell-aem-base/clientlibs/clientlib-base/resources/icons/image_unavailable.svg',
        locale: document.documentElement.lang ? document.documentElement.lang.toLocaleLowerCase() : 'en-us',
    };

    getBasedOnViewsProducts = () => {
        if (!window.localStorage.getItem('pira-pz-recomms')) {
            return { productResultsBasedOnViews: [], productCategoryBasedOnViews: '' };
        }
        const recommendedPageList = JSON.parse(window.localStorage.getItem('pira-pz-recomms'));
        const productResults = [];
        const recommendedCategories = [];
        while (recommendedPageList.length > 0) {
            const recommendedPage = recommendedPageList.shift();
            if (!recommendedPage.page || !recommendedPage.title) {
                continue;
            }
            if (recommendedPage.page.includes('/products/hardware/') && !recommendedPage.page.includes('/products/hardware/allen-bradley')) {
                productResults.push(recommendedPage);
                recommendedCategories.push(recommendedPage.page.replace('/products/hardware', '').replace('.html', ''));
            } else if (recommendedPage.page.includes('/products/hardware/allen-bradley/')) {
                productResults.push(recommendedPage);
                recommendedCategories.push(recommendedPage.page.replace('/products/hardware/allen-bradley', '').replace('.html', ''));
            } else if (recommendedPage.page.includes('/products/details.')) {
                productResults.push(recommendedPage);
            }
        }
        return { productResultsBasedOnViews: productResults.slice(0, this.constants.productsToDisplay), productCategoriesBasedOnViews: recommendedCategories };
    };

    getBestSellingProducts = async () => {
        const bestSellingProducts = [];
        const headers = new Headers();
        headers.append('Content-Type', 'text/plain; charset=UTF-8');
        try {
            const response = await fetch(`${productDetailServletEndpoint}?categoryIds=all&fields=all&sortBy=salesSort--salesOrg_preferredAvailability&startIndex=0&numResults=${this.constants.productsToDisplay}`, {
                method: 'GET',
                headers: headers,
            });
            const responseBuffer = await response.arrayBuffer();
            const responseString = new TextDecoder('ISO-8859-1').decode(responseBuffer);
            console.log('responseString:', responseString);
            const responseJson = JSON.parse(responseString);
            responseJson.docs.forEach((product) => {
                bestSellingProducts.push({
                    title: product.names_value || product.title,
                    description: product.description || product.R_description,
                    imageUrl: product.picture_url || this.constants.defaultImage,
                    page: productDetailsPage + product.catalogNumber + '.html',
                });
            });
        } catch (error) {
            console.warn('Error fetching best selling products:', error);
        }
        return bestSellingProducts;
    }

    createProductElement = async (product) => {
        const productElement = this.elements.productTemplate.cloneNode(true);
        productElement.classList.remove(`${componentName}__product-template`);
        this.addTextContentOrRemove(productElement.querySelector(`.${componentName}__product-title`), product.title);
        this.addTextContentOrRemove(productElement.querySelector(`.${componentName}__product-description`), product.description);
        productElement.querySelector(`.${componentName}__product-image`).addEventListener('error', () => {
            productElement.querySelector(`.${componentName}__product-image`).src = this.constants.defaultImage;
        });
        if (product.imageUrl && !product.imageUrl.endsWith('.html')) {
            productElement.querySelector(`.${componentName}__product-image`).src = product.imageUrl;
        } else if (product.imageUrl && product.imageUrl.endsWith('.html')) {
            productElement.querySelector(`.${componentName}__product-image`).src = await this.getProductImage(`${window.location.origin}/en-us${product.imageUrl}`);
        } else {
            productElement.querySelector(`.${componentName}__product-image`).src = this.constants.defaultImage;
        }
        productElement.querySelector(`.${componentName}__product-image`).alt = product.title;
        productElement.querySelector(`.${componentName}__product-link`).href = `/${this.constants.locale}${product.page}`;
        return productElement;
    };

    getProductImage = async (productUrl) => {
        try {
            const response = await fetch(productUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'text/html; charset=UTF-8',
                },
            });
            console.log('response', response);
            const responseText = await response.text();
            const responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
            console.log('responseDocument', responseDocument);
            const productImage = responseDocument.querySelector('img');
            return productImage.src;
        } catch (error) {
            console.warn('Error fetching product image:', error);
            return this.constants.defaultImage;
        }
    };

    addTextContentOrRemove = (element, textContent) => {
        if (textContent) {
            element.textContent += textContent;
        } else {
            element.remove();
        }
    };

    initDom = async () => {
        const { productResultsBasedOnViews, productCategoriesBasedOnViews } = this.getBasedOnViewsProducts();
        const productResultsBestSelling = await this.getBestSellingProducts();

        if (productResultsBasedOnViews.length > 0) {
            productResultsBasedOnViews.forEach(async (product) => {
                const productElement = await this.createProductElement(product);
                this.elements.basedOnViewsList.appendChild(productElement);
            });
        } else {
            this.elements.container.querySelector(`.${componentName}__content--based-on-views`).remove();
        }
        if (productResultsBestSelling.length > 0) {
            productResultsBestSelling.forEach(async (product) => {
                const productElement = await this.createProductElement(product);
                this.elements.bestSellingList.appendChild(productElement);
            });
        } else {
            this.elements.container.querySelector(`.${componentName}__content--best-selling`).remove();
        }
    };

    /**
     * Initialize Component
     */
    init = () => {
        this.initDom();
    };
}

registerComponent(`.${componentName}`, ProductRecommendations);
